import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const getAuthConfig = () => ({
    headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
});

// Uploaded files are stored as root-relative paths ("/uploads/x.png") so they
// survive host and port changes. S3 URLs and hand-pasted URLs are already
// absolute and pass through untouched.
const backendOrigin = apiBaseUrl.replace(/\/api\/?$/, '');

export const resolveImageUrl = (url) => {
    if (!url) return '';
    if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
    return `${backendOrigin}${url.startsWith('/') ? '' : '/'}${url}`;
};

export const productAPI = {
    getAll: (category = null) => {
        const url = category ? `${apiBaseUrl}/products?category=${category}` : `${apiBaseUrl}/products`;
        return axios.get(url);
    },

    getById: (id) => axios.get(`${apiBaseUrl}/products/${id}`),

    create: (productData) => axios.post(`${apiBaseUrl}/products`, productData, getAuthConfig()),

    update: (id, productData) => axios.put(`${apiBaseUrl}/products/${id}`, productData, getAuthConfig()),

    delete: (id) => axios.delete(`${apiBaseUrl}/products/${id}`, getAuthConfig())
};

export const orderAPI = {
    // Create order - supports both authenticated and guest users
    create: (orderData) => {
        const token = localStorage.getItem('token');
        const config = token ? getAuthConfig() : {};
        return axios.post(`${apiBaseUrl}/orders/create`, orderData, config);
    },

    getAll: () => axios.get(`${apiBaseUrl}/orders`, getAuthConfig()),

    getById: (id) => axios.get(`${apiBaseUrl}/orders/${id}`, getAuthConfig()),

    updateStatus: (id, status) => axios.put(`${apiBaseUrl}/orders/${id}/status`, { status }, getAuthConfig())
};

export const trainingGuideAPI = {
    // Get all published guides (public)
    getAll: () => axios.get(`${apiBaseUrl}/training-guides`),

    // Get single guide by ID (public)
    getById: (id) => axios.get(`${apiBaseUrl}/training-guides/${id}`),

    // Get all guides including unpublished (admin only)
    getAllAdmin: () => axios.get(`${apiBaseUrl}/training-guides/admin/all`, getAuthConfig()),

    // Create new guide (admin only)
    create: (guideData) => axios.post(`${apiBaseUrl}/training-guides`, guideData, getAuthConfig()),

    // Update guide (admin only)
    update: (id, guideData) => axios.put(`${apiBaseUrl}/training-guides/${id}`, guideData, getAuthConfig()),

    // Delete guide (admin only)
    delete: (id) => axios.delete(`${apiBaseUrl}/training-guides/${id}`, getAuthConfig())
};

export const featureFlagAPI = {
    // Get all feature flags (public)
    getAll: () => axios.get(`${apiBaseUrl}/feature-flags`),

    // Get specific feature flag
    getByName: (name) => axios.get(`${apiBaseUrl}/feature-flags/${name}`),

    // Check if feature is enabled
    isEnabled: (name) => axios.get(`${apiBaseUrl}/feature-flags/status/${name}`),

    // Update feature flag (admin only)
    update: (name, data) => axios.put(`${apiBaseUrl}/feature-flags/${name}`, data, getAuthConfig())
};

export default {
    productAPI,
    orderAPI,
    trainingGuideAPI,
    featureFlagAPI
};
